import React, { useState } from 'react';

/**
 * Brand logo with automatic fallback. If `src` 404s (e.g. a stale absolute
 * URL from a prior environment) the component swaps to a letter-avatar
 * built from `name` so the dashboard never shows a broken image icon.
 */
export function BrandLogo({ src, name, size = 56, primaryColor = '#D44E20', className = '', testid }) {
  const [errored, setErrored] = useState(false);
  const letter = (name || 'L').trim().charAt(0).toUpperCase() || 'L';
  const dimension = `${size}px`;

  if (!src || errored) {
    return (
      <div
        className={`rounded-2xl flex items-center justify-center font-bold ${className}`}
        style={{ width: dimension, height: dimension, backgroundColor: `${primaryColor}20`, color: primaryColor, fontSize: size * 0.45 }}
        data-testid={testid || 'brand-logo-fallback'}
        aria-label={name || 'Logo'}
      >
        {letter}
      </div>
    );
  }
  return (
    <img
      src={src}
      alt={name || ''}
      className={`rounded-2xl object-contain ${className}`}
      style={{ width: dimension, height: dimension }}
      onError={() => setErrored(true)}
      data-testid={testid || 'brand-logo'}
    />
  );
}
